( function( $ ) {
	'use strict';

	$( function() {
		const activeClass = 'is-active';
		const offcanvasActiveClass = 'site-offcanvas--is-active';
		const offcanvasSubmenuActiveClass = 'site-offcanvas--submenu-is-active';

		const $menuTrigger = $( '.js-site-offcanvas-trigger' );
		const $item = $( '.js-offcanvas-menu-item' );
		const $trigger = $( '.js-offcanvas-menu-trigger' );
		const $submenu = $( '.js-offcanvas-menu-submenu' );
		const $back = $( '.js-site-offcanvas-back' );
		const $offcanvas = $( '.js-site-offcanvas' );
		const $body     = $('body');

		// all focusable elements in offcanvas
		// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
		const focusableList = [...$offcanvas[0].querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')];
		const lastFocus = focusableList[focusableList.length - 1];

		$back.removeClass( activeClass );
		$back.attr('tabindex', '-1');

		// Add heading to each submenu
		$submenu.each( function() {
			const title = $( this ).closest( $item ).find( $trigger ).first().text().trim();
			$( this ).prepend( `<div class="offcanvas-menu-submenu__title  js-offcanvas-menu-submenu-title">${title}</div>` );
		} );

		$trigger.on( 'click', function( event ) {
			event.preventDefault();
			$($offcanvas).addClass(offcanvasSubmenuActiveClass);
			$( this ).parent().find( $submenu ).first().addClass( activeClass );
			$back.addClass( activeClass );
			$back.removeAttr('tabindex');
		} );

		$back.on( 'click', function() {
			$submenu.filter( `.${activeClass}` ).last().removeClass( activeClass );

			if ( $submenu.filter( `.${activeClass}` ).length === 0 ) {
				$back.removeClass(activeClass);
				$back.attr('tabindex', '-1');
				$offcanvas.removeClass(offcanvasSubmenuActiveClass);
			}
		} );

		$( $submenu ).find( 'a' ).not( $trigger ).on( 'click', function() {
			$body.removeClass(offcanvasActiveClass);
		} );

		$offcanvas[0].addEventListener('keydown', function(event) {
			if (event.key === 'Tab' && !event.shiftKey && document.activeElement === lastFocus) {
				$menuTrigger.click();
			}
		});
	} );
} )( jQuery );
